module.exports = __webpack_public_path__ + "static/media/img20.ccc65eff.png";